export default class Mediator{
	constructor(){
		this.events = {}
	}

	on(eventName, fn, observer) {
		this.events[eventName] = this.events[eventName] || [];
		this.events[eventName].push( { "instance": observer, "callable": fn } )
	}

	off(eventName, fn) {
		if (this.events[eventName]) {
			for (let i = 0; i < this.events[eventName].length; i++) {
				if (this.events[eventName][i].callable === fn) {
					this.events[eventName].splice(i, 1);
					break
				}
			}
		}
	}

	trigger( eventName, data, sender ) {
		if (this.events[eventName]) {
			this.events[eventName].forEach(function( observer ) {
				if ( sender !== observer.instance ) observer.instance[ observer.callable ](data)
			})
		}
	}

}